$( document ).ready( function() {

    // const setBlank = function (obj) {
    //     if (obj.prop('target') == '') {
    //         obj.prop('target', '_blank');
    //     }
    // }

    // const addScreenReaderText = function (obj, alt_text, classes, icon_name, set_target) {

    //     // if (set_target) {
    //     //     setBlank(obj);
    //     // }

    //     obj.html(obj.html() + ' <img alt="' + alt_text + '" class="' + classes + '" src="/wp-content/themes/ombudsman/assets/img/' + icon_name + '">');

    // }

    const addIcon = function (obj, alt_text, classes, icon_name) {

        obj.html(obj.html() + ' <img alt="' + alt_text + '" class="' + classes + '" src="/wp-content/themes/ombudsman/assets/img/' + icon_name + '">');

    }

    // PDF links

    $( 'a[href$=".pdf"]', '#nav--lower, #page-content, footer' ).each(function () {

        $( this ).attr( 'target', '_blank' );

        $( this ).append( ' <span>(PDF)</span>' );

        $( this ).append( '<span class="sr-only">Opens in new tab</span>' );

        const icon = $( this ).hasClass( 'btn-primary' ) || $( this ).hasClass( 'btn-secondary' ) ? 'icon-external-link-white.svg' : 'icon-external-link.svg';

        addIcon( $( this ), '', 'cot-external-link cot-open-new-window ms-1', icon );

    });

    // External links

    $( 'a:not([href^="/"]):not([href^="#"]):not([href^="mailto:"]):not([href^="tel:"]):not([href*="localhost"]):not([href*="ombudsmantoronto.ca"])', '#nav--lower, #page-content, footer' ).each(function () {

        $( this ).attr( 'target', '_blank' );

        if ( $( '.nav-link--title', this ).length > 0 ) {
            $( '.nav-link--title', this ).append( '<span class="sr-only"> Opens in new tab</span>' );
        } else {
            $( this ).append( '<span class="sr-only"> Opens in new tab</span>' );
        }

        if ( $( this ).is( '.nav-link' ) ) return

        const icon = $( this ).hasClass( 'btn-primary' ) || $( this ).hasClass( 'btn-secondary' ) ? 'icon-external-link-white.svg' : 'icon-external-link.svg';

        addIcon( $( this ), '', 'cot-external-link cot-open-new-window ms-1', icon );
        
    });

})